export default "__VITE_ASSET__c63a593b__"